import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CLINIC } from "@/lib/brand";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/conditions", label: "Conditions" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function MarketingHeader() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 glass-header" data-testid="marketing-header">
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-18 py-2 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img src={CLINIC.logoUrl} alt={CLINIC.name} className="w-12 h-12 rounded-full object-cover ring-1 ring-[color:var(--primary-light)]" />
          <div className="leading-tight">
            <p className="font-heading text-[15px] font-medium text-[color:var(--ink)]">{CLINIC.shortName}</p>
            <p className="text-[10px] text-[color:var(--muted)] tracking-[0.18em] uppercase">Homoeopathy Clinic</p>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map(l => (
            <Link
              key={l.to} to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors ${loc.pathname === l.to ? "text-[color:var(--ink)]" : "text-[color:var(--muted)] hover:text-[color:var(--ink)]"}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/login" data-testid="header-login-btn" className="text-sm font-medium text-[color:var(--muted)] hover:text-[color:var(--ink)]">Login</Link>
          <Link to="/book" data-testid="header-book-btn">
            <Button className="rounded-full bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-white px-5 h-9">Book Appointment</Button>
          </Link>
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[color:var(--border)] bg-white px-5 py-3 space-y-2">
          {links.map(l => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-2 text-sm text-[color:var(--ink)]">{l.label}</Link>
          ))}
          <Link to="/login" onClick={() => setOpen(false)} className="block py-2 text-sm text-[color:var(--muted)]">Login</Link>
          <Link to="/book" onClick={() => setOpen(false)} className="block">
            <Button className="w-full rounded-full bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-white">Book Appointment</Button>
          </Link>
        </div>
      )}
    </header>
  );
}
